var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"app-loader"},[_c('circle',{staticClass:"app-loader__circle",attrs:{"cx":"15","cy":"15","r":"8"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }